export default class Button {

    texture
    sprite
    x
    y
    size
    pointerDown

    constructor(texture, x, y, size, pointerDown) {
        this.texture = texture
        this.x = x
        this.y = y
        this.size = size
        this.pointerDown = pointerDown
    }

    setSprite() {
        this.sprite.setDisplaySize(this.size, this.size)
        this.sprite.setInteractive({ cursor: 'pointer' })

        this.sprite.on('pointerover', () => {
            const bumpedSize = this.size * 1.1
            this.sprite.setDisplaySize(bumpedSize, bumpedSize)
        })
        this.sprite.on('pointerdown', () => {
            const bumpedSize = this.size * 1.1
            this.sprite.setDisplaySize(bumpedSize, bumpedSize)
            this.pointerDown()
        })
        this.sprite.on('pointerout', () => {
            this.sprite.setDisplaySize(this.size, this.size)
        })
        this.sprite.on('pointerup', () => {
            this.sprite.setDisplaySize(this.size, this.size)
        })
    }
}
